module.exports = __webpack_public_path__ + "static/assets/15163f896c896491813e00aa13cc33b1.png";